import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface EmailConfig {
  id: string;
  user_id: string;
  email_address: string;
  display_name: string | null;
  is_primary: boolean;
  is_verified: boolean;
  bcc_to_personal: string | null;
}

export function useEmailConfig() {
  const [emailConfigs, setEmailConfigs] = useState<EmailConfig[]>([]);
  const [primaryConfig, setPrimaryConfig] = useState<EmailConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEmailConfigs();
  }, []);

  const fetchEmailConfigs = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setLoading(false);
        return;
      }

      // Get the app_user id first
      const { data: appUser } = await supabase
        .from("app_users")
        .select("id")
        .eq("user_id", user.id)
        .single();

      if (!appUser) {
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from("recruiter_email_configs")
        .select("*")
        .eq("user_id", appUser.id)
        .eq("is_verified", true)
        .order("is_primary", { ascending: false });

      if (error) throw error;

      const configs = (data as EmailConfig[]) || [];
      setEmailConfigs(configs);
      setPrimaryConfig(configs.find((c) => c.is_primary) || configs[0] || null);
    } catch (error) {
      console.error("Error fetching email configs:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    emailConfigs,
    primaryConfig,
    loading,
    refetch: fetchEmailConfigs,
  };
}